import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../../assets/logo.svg';
import { CONTACT_INFO, NAV_LINKS } from '../utils/constants';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className='header'>
            <div className='header-inner'>
                <Link to='/' className='logo-container' onClick={() => setMenuOpen(false)}>
                    <img className='logo-img' src={logo} alt={CONTACT_INFO.businessName} />
                    <span className='logo-text'>
                        <strong>{CONTACT_INFO.businessName}</strong>
                        <small>Private financial advisory</small>
                    </span>
                </Link>

                <button
                    className='menu-toggle'
                    aria-label='Toggle navigation menu'
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen((open) => !open)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <nav className={`nav-items ${menuOpen ? 'open' : ''}`}>
                    <ul>
                        {NAV_LINKS.map((link) => (
                            <li key={link.path}>
                                <NavLink to={link.path} onClick={() => setMenuOpen(false)}>
                                    {link.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
